/**
 * Brazilian Portuguese (pt-BR) mappings for Settings
 */

export const settingsPtBR = {
  // Page title and header
  "Settings": "Configurações",
  "Personalize your PickStar experience": "Personalize sua experiência PickStar",
  "Configuration": "Configuração",
  
  // Navigation items
  "Stats & Achievements": "Estatísticas e Conquistas",
  "Track your progress and unlock achievements": "Acompanhe seu progresso e desbloqueie conquistas",
  "Subscription": "Assinatura",
  "Manage your subscription plan and billing": "Gerencie seu plano de assinatura e cobrança",
  "Profile": "Perfil",
  "Update your personal information and preferences": "Atualize suas informações pessoais e preferências",
  "Language": "Idioma",
  "Choose your preferred interface language": "Escolha seu idioma de interface preferido",
  "Notifications": "Notificações",
  "Customize your notification preferences": "Personalize suas preferências de notificação",
  "Privacy & Security": "Privacidade e Segurança",
  "Manage your privacy settings and security options": "Gerencie suas configurações de privacidade e opções de segurança",
  "Appearance": "Aparência",
  "Customize the look and feel of your experience": "Personalize a aparência da sua experiência",
  
  // Mobile selector
  "Tap to change section": "Toque para mudar de seção",
  
  // User info
  "User": "Usuário",
  "Sign Out": "Sair",
  
  // Account section
  "Personal Information": "Informações Pessoais",
  "Full Name": "Nome Completo",
  "Enter your name": "Digite seu nome",
  "Email Address": "Endereço de Email",
  "Save Changes": "Salvar Alterações",
  "Account Preferences": "Preferências da Conta",
  "Email Notifications": "Notificações por Email",
  "Receive updates and alerts": "Receba atualizações e alertas",
  "Two-Factor Authentication": "Autenticação de Dois Fatores",
  "Enhanced account security": "Segurança aprimorada da conta",
  "Sign in to manage your account settings": "Entre para gerenciar suas configurações de conta",
  
  // Gamification section
  "Sign in to view your stats and achievements": "Entre para ver suas estatísticas e conquistas",
  
  // Language section
  "Language Preferences": "Preferências de Idioma",
  "Choose your preferred interface language": "Escolha seu idioma de interface preferido",
  "Your language preference will be applied across the entire PickStar platform for a personalized experience.": "Sua preferência de idioma será aplicada em toda a plataforma PickStar para uma experiência personalizada.",
  
  // Coming soon sections
  "Coming Soon": "Em Breve",
  "We're crafting an amazing experience for this feature. Stay tuned for updates!": "Estamos criando uma experiência incrível para este recurso. Fique atento às atualizações!",
  
  // Logout confirmation
  "Are you sure you want to log out of your account?": "Tem certeza de que deseja sair da sua conta?"
};